import { render, staticRenderFns } from "./OrganisationLocationsList.vue?vue&type=template&id=581c304a&scoped=true&"
import script from "./OrganisationLocationsList.vue?vue&type=script&lang=js&"
export * from "./OrganisationLocationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581c304a",
  null
  
)

export default component.exports